import { useTranslation, Trans } from 'react-i18next'
import { Dialog, Box, Text, ButtonLink, TextLink } from '@machobear/design-system'

import { DialogEventHandler } from '@/types'
import ErrorIllustrationSVG from './error.svg?react'

interface NoBillingUserModalProps {
  open: boolean
  onClose: DialogEventHandler
}

const NoBillingUserDialog = ({ open, onClose }: NoBillingUserModalProps) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} title="" id="billing-user-valid" onClose={onClose} width="xsmall">
      <Box display="flex" alignItems="center" flexDirection="column">
        <ErrorIllustrationSVG />
        <Box marginTop="gutter" width="full">
          <Text weight="strong" size="xlarge" align="center">
            {t('l.billing_details.error.modal.title', 'Billing details required')}
          </Text>
        </Box>
        <Box marginTop="small">
          <Trans t={t} i18nKey="l.billing_details.error.modal.description">
            <Text tone="secondary">
              Oops! It looks like your company billing is not set up. Please contact{' '}
              <TextLink href="mailto:support@liv.rent">support@liv.rent</TextLink> to get started.
            </Text>
          </Trans>
        </Box>
        <Box marginTop="large" width="full">
          <ButtonLink href="mailto:support@liv.rent">
            {t('common.contact_us', 'Contact us')}
          </ButtonLink>
        </Box>
      </Box>
    </Dialog>
  )
}

export default NoBillingUserDialog
